import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss'],
  standalone: false
})

export class AnnouncementBannerComponent {
  @Input() panelClass = 'flex items-center justify-center w-full px-20 font-semibold text-white py-15 bg-gray-800 gap-x-10';
}
